import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Box, Button, Card, CardActions, CardContent, Chip, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { listDatesInfo, listInfoActions, listInfoCard, listInfoContent } from "../../styles/frequentListStyles";
import { getIntervalOptions } from "../../utils/frequentListUtils";
import { formatDate, getNextUseDate, getTimeAgo } from "./utils";

export const ListInfoCard = ({ activeList, onAddToCart }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const intervalOptions = useMemo(() => getIntervalOptions(t), [t]);

  if (!activeList) return null;

  const nextUseDate = activeList.lastUsed ? getNextUseDate(activeList.lastUsed, activeList.interval) : null;

  const isOverdue = nextUseDate ? nextUseDate < new Date() : false;

  return (
    <Card variant="outlined" sx={listInfoCard}>
      <CardContent>
        <Box sx={listInfoContent}>
          <Typography variant="h6" component="div">
            {activeList.name}
          </Typography>
          <Box>
            <Tooltip title={t("frequentItems.recurrenceInterval")}>
              <Chip
                icon={<AccessTimeIcon />}
                label={intervalOptions.find((opt) => opt.value === activeList.interval)?.label || `${activeList.interval} ${t("frequentItems.days")}`}
                variant="outlined"
                size="small"
              />
            </Tooltip>
          </Box>
        </Box>
        <Box sx={listDatesInfo}>
          {activeList.lastUsed ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {t("frequentItems.lastAddedToCart")}: {getTimeAgo(activeList.lastUsed)}, {formatDate(activeList.lastUsed)}
            </Typography>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {t("frequentItems.neverAddedToCart")}
            </Typography>
          )}
          {activeList.lastUsed && (
            <Typography variant="body2" sx={{ color: isOverdue ? theme.palette.error.main : "text.secondary" }}>
              {t("frequentItems.suggestedNextUse")}: {formatDate(nextUseDate)}
            </Typography>
          )}
        </Box>
      </CardContent>
      <CardActions sx={listInfoActions}>
        <Button size="small" startIcon={<ShoppingCartIcon />} onClick={onAddToCart}>
          {t("frequentItems.addAllToCart")}
        </Button>
      </CardActions>
    </Card>
  );
};
